import projectApi from '@/api/project';
import memberApi from '@/api/projectMember';

let requestIsSent = false;

export default {
  namespaced: true,
  state: () => ({
    project: null,
    requestCounter: 0,
    requestError: false,
  }),
  getters: {
    members(state) {
      return [
        state.project.author,
        ...state.project?.projectMembers?.map((m) => m.user),
      ];
    },
  },
  mutations: {
    setProject(state, project) { state.project = project; },
    setProjectArchived(state, isArchived) { state.project.isArchived = isArchived; },
    setProjectAuthor(state, author) { state.project.author = author; },
    addMember(state, member) { state.project.projectMembers.push(member); },
    updateMember(state, { member, role, id }) {
      const memberInState = state.project.projectMembers.find((m) => m.user.id === member.user.id);
      if (role) memberInState.role = role;
      if (id) memberInState.id = id;
    },
    removeMember(state, member) {
      state.project.projectMembers = state.project.projectMembers.filter((m) => m.id !== member.id);
    },
    setStatuses(state, statuses) {
      state.project.taskStatuses = statuses;
    },
    incRequestCnt(state) { state.requestCounter += 1; },
    decRequestCnt(state) { state.requestCounter -= 1; },
    setError(state) { state.requestError = true; },
  },
  actions: {
    fetchProject({ state, commit }, { projectId, force }) {
      if (requestIsSent) return;
      if (state.project?.id === projectId && !force) return;

      requestIsSent = true;

      projectApi.fetchItem(projectId, true)
        .then((r) => {
          commit('setProject', r);
          commit('stage/setItems', r.stages, { root: true });
        })
        .finally(() => { requestIsSent = false; });
    },
    updateAuthor({ state, commit }, author) {
      commit('setProjectAuthor', author);
      commit('incRequestCnt');
      projectApi.update(state.project.id, { author: author['@id'] })
        .then(() => { commit('decRequestCnt'); })
        .catch(() => { commit('setError'); });
    },

    addMember({ state, commit }, { user, role }) {
      const member = { user, role, id: null };
      commit('addMember', member);
      commit('incRequestCnt');
      memberApi.create({ user: user['@id'], project: state.project['@id'], role })
        .then((r) => {
          commit('updateMember', { member, id: r.id });
          commit('decRequestCnt');
        })
        .catch(() => { commit('setError'); });
    },
    updateMemberRole({ commit }, { member, role }) {
      commit('updateMember', { member, role });
      commit('incRequestCnt');
      memberApi.update(member.id, { role })
        .then(() => { commit('decRequestCnt'); })
        .catch(() => { commit('setError'); });
    },
    deleteMember({ commit }, member) {
      commit('removeMember', member);
      commit('incRequestCnt');
      memberApi.delete(member.id)
        .then(() => { commit('decRequestCnt'); })
        .catch(() => { commit('setError'); });
    },
  },
};
